import { Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomFuelChargeBuildTable extends Layout {
    textboxBaseCharge: Textbox;
    textboxEnd: Textbox;
    textboxFuelPriceIncrement: Textbox;
    textboxMethod: Textbox;
    textboxStart: Textbox;
    textboxSurchargeIncrememnt: Textbox;
}
